import axios from '@/api/axios'

// 服务器代理地址
const BASE_URL = process.env.VUE_APP_BASE_URL

// ---------------------------------------- 《 公 共 》

// 获取七牛token
// export function getUploadToken (parameter) {
//   return axios({
//     url: BASE_URL + '/qiniu/get_token',
//     method: 'get',
//     params: parameter
//   })
// }

// 获取阿里云token
export function getUploadToken(parameter) {
  return axios({
    url: BASE_URL + '/oss/get_token',
    method: 'get',
    params: parameter
  })
}

// 获取火山云token
export function getUploadHuoShanToken(parameter) {
  return axios({
    url: BASE_URL + '/oss/get_huoshan_token',
    method: 'get',
    params: parameter
  })
}

// ---------------------------------------- 《任务管理》

// 任务库 — 列表
export function taskList(parameter) {
  return axios({
    url: BASE_URL + '/task/list',
    method: 'get',
    params: parameter
  })
}

// 任务库 — 详情
export function taskDetail(parameter) {
  return axios({
    url: BASE_URL + '/task/detail',
    method: 'get',
    params: parameter
  })
}

// 任务库 — 状态设置
export function taskStatus(parameter) {
  return axios({
    url: BASE_URL + '/task/task_status',
    method: 'post',
    data: parameter
  })
}

// 任务库 — 切换剧集
export function taskUpdatePlaylet(parameter) {
  return axios({
    url: BASE_URL + '/task/task_update_playlet',
    method: 'post',
    data: parameter
  })
}

// 任务库 — 剧场检索
export function appSelectList(parameter) {
  return axios({
    url: BASE_URL + '/task/app_all',
    method: 'get',
    params: parameter
  })
}

// 短剧库 — 列表
export function dramaList(parameter) {
  return axios({
    url: BASE_URL + '/task/playlet_list',
    method: 'get',
    params: parameter
  })
}

// 短剧库 — 编辑
export function dramaEdit(parameter) {
  return axios({
    url: BASE_URL + '/task/playlet_save',
    method: 'post',
    data: parameter
  })
}

// 短剧库 — 检索
export function dramaSelectList(parameter) {
  return axios({
    url: BASE_URL + '/task/playlet_all',
    method: 'get',
    params: parameter
  })
}

// 待入库 — 列表
export function storageList(parameter) {
  return axios({
    url: BASE_URL + '/task/store_list',
    method: 'get',
    params: parameter
  })
}

// 待入库 — 入库校验/不入库
export function storageCheck(parameter) {
  return axios({
    url: BASE_URL + '/task/store_check',
    method: 'post',
    data: parameter
  })
}

// 待入库 — 入库
export function storageSet(parameter) {
  return axios({
    url: BASE_URL + '/task/set_store',
    method: 'post',
    data: parameter
  })
}

// 待入库 — 入库（修改比例）
export function storageSetModify(parameter) {
  return axios({
    url: BASE_URL + '/task/set_rate',
    method: 'post',
    data: parameter
  })
}

// 待入库 — 抓取融合任务
export function storageRefreshData(parameter) {
  return axios({
    url: BASE_URL + '/task/refresh_data',
    method: 'get',
    params: parameter
  })
}

// ---------------------------------------- 《配套设置》

// 渠道 - 检索列表
export function channelSelectList(parameter) {
  return axios({
    url: BASE_URL + '/config/channel_all',
    method: 'get',
    params: parameter
  })
}

// 渠道 - 列表
export function channelList(parameter) {
  return axios({
    url: BASE_URL + '/config/channel_list',
    method: 'get',
    params: parameter
  })
}

// 渠道 - 保存
export function channelSave(parameter) {
  return axios({
    url: BASE_URL + '/config/channel_save',
    method: 'post',
    data: parameter
  })
}

// 渠道 - 开关
export function channelStatus(parameter) {
  return axios({
    url: BASE_URL + '/config/channel_status',
    method: 'post',
    data: parameter
  })
}

// 渠道 - 移动
export function channelSort(parameter) {
  return axios({
    url: BASE_URL + '/config/channel_sort',
    method: 'post',
    data: parameter
  })
}

// 版权方 - 列表
export function supplierList(parameter) {
  return axios({
    url: BASE_URL + '/config/supplier_list',
    method: 'get',
    params: parameter
  })
}

// 版权方 - 新增/编辑
export function supplierSave(parameter) {
  return axios({
    url: BASE_URL + '/config/supplier_save',
    method: 'post',
    data: parameter
  })
}

// 客户端 - 列表
export function clientList(parameter) {
  return axios({
    url: BASE_URL + '/config/client_list',
    method: 'get',
    params: parameter
  })
}

// 客户端 - 新增/编辑
export function clientSave(parameter) {
  return axios({
    url: BASE_URL + '/config/client_save',
    method: 'post',
    data: parameter
  })
}

// 类型 - 检索列表
export function classifySelectList(parameter) {
  return axios({
    url: BASE_URL + '/classify_all',
    method: 'get',
    params: parameter
  })
}

// 类型 - 列表
export function classifyList(parameter) {
  return axios({
    url: BASE_URL + '/classify_list',
    method: 'get',
    params: parameter
  })
}

// 类型 - 新增
export function classifyAdd(parameter) {
  return axios({
    url: BASE_URL + `/setup/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 类型 - 更新
export function classifyUpdate(parameter) {
  return axios({
    url: BASE_URL + `/setup/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 类型 - 移动
export function classifySort(parameter) {
  return axios({
    url: BASE_URL + `/sort/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 类型 - 状态
export function classifyState(parameter) {
  return axios({
    url: BASE_URL + `/status/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// ---------------------------------------- 《前台设置》

// banner - 列表
export function bannerList(parameter) {
  return axios({
    url: BASE_URL + '/front/banner/list',
    method: 'get',
    params: parameter
  })
}

// banner - 新增/编辑
export function bannerSave(parameter) {
  return axios({
    url: BASE_URL + '/front/banner/save',
    method: 'post',
    data: parameter
  })
}

// banner - 排序
export function bannerSort(parameter) {
  return axios({
    url: BASE_URL + '/front/banner/sort',
    method: 'post',
    data: parameter
  })
}

// banner - 删除
export function bannerDelete(parameter) {
  return axios({
    url: BASE_URL + '/front/banner/delete',
    method: 'post',
    data: parameter
  })
}

// 前台配置 - 列表
export function frontdeskList(parameter) {
  return axios({
    url: BASE_URL + '/setting/list',
    method: 'get',
    params: parameter
  })
}

// 前台配置 - 新增/编辑
export function frontdeskSave(parameter) {
  return axios({
    url: BASE_URL + '/setting/save',
    method: 'post',
    data: parameter
  })
}

// ---------------------------------------- 《达人管理》

// 达人 - 列表
export function darenList(parameter) {
  return axios({
    url: BASE_URL + '/user/list',
    method: 'get',
    params: parameter
  })
}

// 达人 - 禁用/启用
export function darenEnable(parameter) {
  return axios({
    url: BASE_URL + '/user/user_status',
    method: 'post',
    data: parameter
  })
}

// 提现单 - 已提现/待提现列表
export function darenWithdrawList(parameter) {
  return axios({
    url: BASE_URL + '/user/cash_list',
    method: 'get',
    params: parameter
  })
}

// 提现单 - 打款成功
export function darenWithdrawSuccess(parameter) {
  return axios({
    url: BASE_URL + '/user/cash_pay',
    method: 'get',
    params: parameter
  })
}

// 提现单 - 打款失败
export function darenWithdrawFail(parameter) {
  return axios({
    url: BASE_URL + '/user/cash_pay_fail',
    method: 'post',
    data: parameter
  })
}

// ---------------------------------------- 《系统设置》

// 权限管理 - 列表
export function permissionList(parameter) {
  return axios({
    url: BASE_URL + `/permission/list/${parameter.source}`,
    method: 'get',
    params: parameter
  })
}

// 权限管理 - 新增
export function permissionStore(parameter) {
  return axios({
    url: BASE_URL + `/permission/edit/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 权限管理 - 编辑
export function permissionUpdate(parameter) {
  return axios({
    url: BASE_URL + `/permission/edit/${parameter.source}`,
    method: 'post',
    data: parameter
  })
}

// 权限管理 - 层级列表
export function permissionSearch(parameter) {
  return axios({
    url: BASE_URL + `/permission/search/${parameter.source}`,
    method: 'get',
    params: parameter
  })
}

// 权限管理 - 删除
export function permissionDelete(parameter) {
  return axios({
    url: BASE_URL + `/permission/delete`,
    method: 'post',
    data: parameter
  })
}

// ----------------------------------------《账号管理》

// 用户权限菜单
export function userMenusPermissions(parameter) {
  return axios({
    url: BASE_URL + '/user/menus',
    method: 'post',
    data: parameter
  })
}

// 账号管理 - 列表
export function userList(parameter) {
  return axios({
    url: BASE_URL + `/user/user_list`,
    method: 'get',
    params: parameter
  })
}

// 账号管理 - 新增/编辑
export function userEdit(parameter) {
  return axios({
    url: BASE_URL + `/user/save_user`,
    method: 'post',
    data: parameter
  })
}

// 修改密码
export function userUpdatePassword(parameter) {
  return axios({
    url: BASE_URL + `/user/update_password`,
    method: 'post',
    data: parameter
  })
}

// 账号管理 - 删除
export function userDelete(parameter) {
  return axios({
    url: BASE_URL + `/user/delete_user`,
    method: 'post',
    data: parameter
  })
}

// 账号管理 - 权限列表
export function userMenuList(parameter) {
  return axios({
    url: BASE_URL + `/menu/menu_list`,
    method: 'get',
    params: parameter
  })
}

// 账号管理 - 权限列表保存
export function userMenuSave(parameter) {
  return axios({
    url: BASE_URL + `/menu/menu_save`,
    method: 'post',
    data: parameter
  })
}